import { useFormikContext } from "formik";
import { FC, useEffect } from "react";
import { EMPTY_STRING } from "../../../../common/constants/common.constants";

import { IDetailNftData } from "../../../../common/interfaces/common.interface";
import {
  ICreateProposalForm,
  ICreateProposalProps,
} from "../../../../common/interfaces/proposals.interface";
import Fees from "../../../Fees/Fees";
import "./BuyNftProposal.scss";
import MintPrice from "./MintPrice/MintPrice";
import BuyingNftData from "./BuyingNftData";
import useTransactionStore from "../../../../contexts/transactionStore";
import { ProposalBuyOption } from "../../../../common/enums/proposals.enums";
import { clubsStore } from "../../../../contexts/clubStore";

const BuyNftProposal: FC<{
  form: ICreateProposalProps;
  validateNftMint: () => void;
  nftData: IDetailNftData;
}> = ({ form, nftData, validateNftMint }) => {
  const { treasury } = clubsStore();
  const { values, errors } = useFormikContext<ICreateProposalForm>();
  const { setNftData } = useTransactionStore.getState();

  const isPriceGreaterThenTreasuryAmount =
    treasury &&
    values.price >
      (treasury.tokenAccounts.find(
        (item) => item.mint.toString() === values.mint.toString()
      )?.balance ?? 0);

  useEffect(() => {
    if (values.buyOption === ProposalBuyOption.MagicEden) setNftData(nftData);
  }, [nftData]);

  return (
    <div className="buy-nft-proposal">
      <MintPrice form={form} validateNftMint={validateNftMint} />

      {!errors["nftToBuy"] && values.nftToBuy !== EMPTY_STRING && nftData && (
        <BuyingNftData nftData={nftData} />
      )}
      {isPriceGreaterThenTreasuryAmount && (
        <Fees
          feesTitle="You don't have enough funds. "
          feesDescription="Please assure that the treasury has enough funds at the proposal execution stage."
          alert={true}
          buySell
        />
      )}
    </div>
  );
};

export default BuyNftProposal;
